import {
  CheckMandatory,
  DeleteRecord,
  ErrorAlert,
  getList,
  GetListDropdown,
  GetRecords,
  saveRecord,
  SuccessAlert,
  UpdateRecord,
  URLPRIFIX,
  WarningAlert,
} from "../../../functions/api";
import React, { useEffect, useState } from "react";
import { resolvePath, useLocation, useParams } from "react-router-dom";
import String from "../../../Components/Fields/String";
import { useStore } from "../../../Components/StateProvider";
import FormView from "../../../Components/Elements/FormView";
import ListView from "../../../Components/Elements/ListView";
import DatePicker from "../../../Components/Fields/DatePicker";
import Journal from "../../../Components/Fields/Journal";
import { getlocal } from "../../../functions/localstorage";
import Attachement from "../../../Components/Fields/Attachement";
import FileInput from "../../../Components/Fields/FileInput";
import { PrimaryBTN, secondaryBTN } from "../../../Constancs/cssconst";
import Dropdown from "../../../Components/Fields/Dropdown";
import { FaCheck, FaEdit, FaTimes, FaTrash } from "react-icons/fa";

const TProjectForm = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { option, id } = useParams();
  const user = getlocal("system")?.user || {};
  const tablename = "projects";
  const getrecord = `/project/getproject/${id}/13`;
  const updaterecord = `/project/updateproject/${id}/13`;
  const setrecord = "/project/createproject/13";
  const [GenerateInvoice, setGenerateInvoice] = useState(false);
  const [CompanyList, setCompanyList] = useState([
    { label: "Please Choose", value: "" },
  ]);
  const [CompanyNumber, setCompanyNumber] = useState("");

  const store = useStore();
  const init = {
    projectName: "",
    projectDescription: "",
    contact_id: "",
    startDate: "",
    endDate: "",
    priority: "",
    status: "Draft",
    activeStatus: true,
    attachmenturl: [],
  };

  useEffect(() => {
    console.log("queryParams", queryParams.get("projectName") === null);
    store
      .setmodule("trademark_project", init)
      .then((res) => console.log("autofill check", res));
    if (id != undefined) {
      store.setheader(option.toUpperCase() + " " + tablename);
      store.setprops("activeStatus", { hidden: false });
      store.setprops("category_id", { hidden: false, readonly: true });

      // props for the Mandatory field
      store.setprops(
        "projectName",
        queryParams.get("projectName")
          ? {
            mandatory: queryParams.get("projectName").includes("mandatory"),
            readonly: queryParams.get("projectName").includes("readonly"),
            hidden: queryParams.get("projectName").includes("hidden"),
          }
          : { mandatory: false }
      );
      store.setprops(
        "projectDescription",
        queryParams.get("projectDescription")
          ? {
            mandatory: queryParams
              .get("projectDescription")
              .includes("mandatory"),
            readonly: queryParams
              .get("projectDescription")
              .includes("readonly"),
            hidden: queryParams.get("projectDescription").includes("hidden"),
          }
          : { mandatory: false }
      );

      store.setprops(
        "contact_id",
        queryParams.get("contact_id")
          ? {
            mandatory: queryParams.get("contact_id").includes("mandatory"),
            readonly: queryParams.get("contact_id").includes("readonly"),
            hidden: queryParams.get("contact_id").includes("hidden"),
          }
          : { mandatory: false }
      );
      store.setprops(
        "startDate",
        queryParams.get("startDate")
          ? {
            mandatory: queryParams.get("startDate")?.includes("mandatory"),
            readonly: queryParams.get("startDate")?.includes("readonly"),
            hidden: queryParams.get("startDate")?.includes("hidden"),
          }
          : { mandatory: false }
      );
      store.setprops(
        "endDate",
        queryParams.get("endDate")
          ? {
            mandatory: queryParams.get("endDate")?.includes("mandatory"),
            readonly: queryParams.get("endDate")?.includes("readonly"),
            hidden: queryParams.get("endDate")?.includes("hidden"),
          }
          : { mandatory: false }
      );

      store.setprops(
        "priority",
        queryParams.get("priority")
          ? {
            mandatory: queryParams.get("priority")?.includes("mandatory"),
            readonly: queryParams.get("priority")?.includes("readonly"),
            hidden: queryParams.get("priority")?.includes("hidden"),
          }
          : { mandatory: false }
      );

      LoadInitData();
      GetAssigntoList();
    } else {
      gettemplateType();
      store.setheader("CREATE NEW " + tablename);
      store.setprops("activeStatus", { hidden: true });
      store.setprops("status", { hidden: true });

      // store.setvalue("status", "Draft");
      // props for the Mandatory field
      store.setprops(
        "projectName",
        queryParams.get("projectName")
          ? {
            mandatory: queryParams.get("projectName").includes("mandatory"),
            readonly: queryParams.get("projectName").includes("readonly"),
            hidden: queryParams.get("projectName").includes("hidden"),
          }
          : { mandatory: true }
      );
      store.setprops(
        "contact_id",
        queryParams.get("contact_id")
          ? {
            mandatory: queryParams.get("contact_id").includes("mandatory"),
            readonly: queryParams.get("contact_id").includes("readonly"),
            hidden: queryParams.get("contact_id").includes("hidden"),
          }
          : { mandatory: true }
      );
      store.setprops(
        "startDate",
        queryParams.get("startDate")
          ? {
            mandatory: queryParams.get("startDate")?.includes("mandatory"),
            readonly: queryParams.get("startDate")?.includes("readonly"),
            hidden: queryParams.get("startDate")?.includes("hidden"),
          }
          : { mandatory: true }
      );
      store.setprops(
        "endDate",
        queryParams.get("endDate")
          ? {
            mandatory: queryParams.get("endDate")?.includes("mandatory"),
            readonly: queryParams.get("endDate")?.includes("readonly"),
            hidden: queryParams.get("endDate")?.includes("hidden"),
          }
          : { mandatory: true }
      );

      store.setprops(
        "priority",
        queryParams.get("priority")
          ? {
            mandatory: queryParams.get("priority")?.includes("mandatory"),
            readonly: queryParams.get("priority")?.includes("readonly"),
            hidden: queryParams.get("priority")?.includes("hidden"),
          }
          : { mandatory: false }
      );
      store.setprops(
        "projectDescription",
        queryParams.get("projectDescription")
          ? {
            mandatory: queryParams
              .get("projectDescription")
              ?.includes("mandatory"),
            readonly: queryParams
              .get("projectDescription")
              ?.includes("readonly"),
            hidden: queryParams.get("projectDescription")?.includes("hidden"),
          }
          : { mandatory: false, readonly: false }
      );
    }

    GetListDropdown({
      listUrl: "/api/v2/Customer/getclients",
      field: "clientname",
      sort: "asc",
      count: 5000,
      store: store,
    });
  }, [option, id]);

  // function gettemplateType() {
  //   GetRecords("/subtask/gettasktemplatetypes").then((res) => {
  //     if (res.success) {
  //       res = res?.record || [];
  //       res = res.map((artist) => ({
  //         value: artist.taskType,
  //         label: artist.taskType,
  //       }));
  //       store.setprops("taskTemplate_list", res);
  //     } else {
  //       store.setprops("taskTemplate_list", []);
  //     }
  //   });
  // }
  // async function createTemplatetask(Records, documentid) {
  //   // console.log("Trade:",Records);

  //   if (documentid != "" && documentid != undefined) {
  //     await GetRecords(
  //       "/subtask/gettasktemplatelist?task_type=" + Records.taskTemplate
  //     ).then(async (res) => {
  //       console.log("gettasktemplatelist", res, documentid, Records);
  //       var NewTask = {
  //         project_id: 0,
  //         contact_id: 0,
  //         form_id: 0,
  //         film_id: 0,
  //         task_id: 0,
  //         subtask_title: "",
  //         assigned_to: 0,
  //         priority: "",
  //         status: "Draft",
  //         description: "",
  //         complete_note: "",
  //         rejected_reason: "",
  //         hold_note: "",
  //         createdBy: store.getuser().id,
  //         modifiedBy: store.getuser().id,
  //         comments: "",
  //         type: 13,
  //       };

  //       if (res.success) {
  //         res = res?.record || [];

  //         res = res.map((item) => {
  //           return {
  //             ...NewTask,
  //             subtask_title: item.task_title,
  //             project_id: documentid,
  //             contact_id: Records.contact_id,
  //             priority: Records.priority,
  //             // dueDate: Records.dueDate,
  //             // assigned_to: Records.assigned_to,

  //           };
  //         });

  //         if (res.length > 0) {
  //           await saveRecord("/subtask/addmanysubtasks/13", res).then(
  //             (saved) => {
  //               console.log("gettasktemplatelist", saved);
  //             }
  //           );
  //         }
  //       }
  //     });
  //   }
  // }


  async function createTemplatetask(formData, projectid) {
    if (!formData.taskTemplate || formData.taskTemplate === "") return;

    // 1. Get the ORDERED workflow tasks for this specific template ID
    await GetRecords(`/template/getworkflow/${formData.taskTemplate}`).then(async (res) => {
      if (res.success) {
        const workflowTasks = res.record || [];

        // Rolling due date: each task starts where the previous one ends
        let rollingDate = new Date();

        const subtasksToSave = workflowTasks.map((item, idx) => {
          let calcDate = new Date(rollingDate);
          calcDate.setDate(calcDate.getDate() + (item.duration_days || 0));
          rollingDate = new Date(calcDate);

          return {
            project_id: projectid,
            contact_id: formData.contact_id,
            subtask_title: item.task_name,
            assigned_to: item.assigned_to_user_id || 0,
            priority: formData.priority || "Medium",
            status: "Draft",
            dueDate: calcDate.toISOString(),
            createdBy: store.getuser().id,
            modifiedBy: store.getuser().id,
            type: 13, // Trademark
            // KEY: These two fields enable sequential workflow enforcement
            order_index: item.order_index,          // sequential position (1, 2, 3...)
            template_workflow_id: item.id,          // link back to template workflow row
          };
        });

        if (subtasksToSave.length > 0) {
          await saveRecord("/subtask/addmanysubtasks/13", subtasksToSave).then((saved) => {
            console.log("[TM createTemplatetask] Template tasks saved:", saved);
            if (saved.success) {
              SuccessAlert(`${subtasksToSave.length} workflow task(s) created from template!`);
            }
          });
        }
      }
    });
  }




  // Change this function to fetch from Template Master
  function gettemplateType() {
    GetRecords("/template/gettemplates").then((res) => {
      if (res.success) {
        const templateData = res.record || [];
        const formattedList = templateData.map((item) => ({
          value: item.id, // Pass ID to backend
          label: item.template_name,
        }));
        store.setprops("taskTemplate_list", [
          { value: "", label: "Select Template" },
          ...formattedList
        ]);
      } else {
        store.setprops("taskTemplate_list", []);
      }
    });
  }

  function LoadInitData() {
    GetRecords(getrecord).then(async (res) => {
      console.log(tablename + " Data - ", res, res.record);
      if (res.success) {
        let records = {
          ...init,
          projectName: res.record.parent.projectName,
          contact_id: res.record.parent.contact_id,
          projectDescription: res.record.parent.projectDescription,
          startDate: res.record.parent.startDate,
          endDate: res.record.parent.endDate,
          priority: res.record.parent.priority,
          status: res.record.parent.status,
          activeStatus: res.record.parent.activeStatus,
          attachmenturl: res.record.parent.attachmenturl || [],
        };

        records.child = {};

        if (option === "view") {
          if (res?.record?.tasks?.length > 0) {
            var tasks = res?.record?.tasks || [];
            tasks = tasks.map((item) => {
              if (item.type == 11) {
                item.type = "Non-Litigation";
              } else if (item.type == 12) {
                item.type = "Litigation";
              } else if (item.type == 13) {
                item.type = "TradeMark";
              }
              if (item.assigned_to == 0) {
                item.assigned_to_username = "UnAssigned";
              }
              return { ...item };
            });

            records.child.tasks = {
              list: tasks,
              header: [
                // ["Select", "select"],
                ["Task Title", "subtask_title"],
                ["type", "type"],
                ["Priority", "priority"],
                ["Assigned To", "assigned_to_username"],
                ["Status", "status"],
                ["Due Date", "dueDate"],
                // ["ActiveStatus", "activeStatus"],
                // ["Action", "ACTION"],
              ],
            };
          }
          if (res?.record?.invoices?.length > 0) {
            records.child.invoices = {
              list: res?.record?.invoices,
              header: [
                ["Invoice No", "invoice_no"],
                ["Company Name", "company_Name"],
                ["Amount", "invoice_total"],
                ["Due Amount", "invoice_due_amount"],
                ["Due Date", "invoice_due_date"],
                ["Status", "invoice_status"],
                // ["Action", "ACTION"],
              ],
            };
          }
          store.setprops("projectName", { hidden: false, readonly: true });
          store.setprops("contact_id", { hidden: false, readonly: true });
          store.setprops("projectDescription", {
            hidden: false,
            readonly: true,
          });
          store.setprops("startDate", { hidden: false, readonly: true });
          store.setprops("endDate", { hidden: false, readonly: true });
          store.setprops("priority", { hidden: false, readonly: true });
          store.setprops("status", { hidden: false, readonly: true });
          store.setprops("activeStatus", { hidden: false, readonly: true });
        } else if (option === "edit") {
          store.setprops("status", { hidden: false, readonly: false });
        }
        console.log(tablename + " Data - ", records);

        store.reset(records);
      }
    });
  }
  async function GetAssigntoList() {
    GetListDropdown({
      listUrl: "/users/getusers",
      field: "userName",
      sort: "asc",
      count: 100,
      store: store,
    });
    await getList({
      listUrl: "/users/getusers",
      field: "userName",
      sort: "asc",
      count: 10000,
    }).then((users) => {
      if (users.success) {
        users = users?.data?.list || [];
        console.log("userName_list", users);
        users = users.map((user) => ({
          ...user,
          value: user.id,
          label: user.firstName + " " + user.lastName,
        }));
        users.splice(0, 0, {
          value: 0,
          label: "UnAssigned",
        });
        store.setprops("userName_list", users);
      }
    });
  }

  useEffect(() => {
    console.log("State Updates", store.state.records.trademark_project);
  }, [store.state.records.trademark_project]);

  function update() {
    store.startLoading();
    let data = store.getrecord();
    data.modifiedBy = store.getuser().id;
    data.id = Number(id);
    data.attachment_url = data.attachmenturl;
    console.log("update", data);

    if (typeof data.activeStatus === "string") {
      data.activeStatus = data.activeStatus == "true" ? true : false;
    }
    UpdateRecord(updaterecord, data).then((res) => {
      console.log("Responce of updateRecord - ", res);

      if (res.success) {
        store.stopLoading();
        SuccessAlert("Project Updated Successfully");
        store.navTo(
          "/" + URLPRIFIX + "/trademark/projects/view/" + res.Id.response.id,
          { replace: true }
        );
      } else {
        store.stopLoading();
        ErrorAlert(
          res?.errormessage?.data || " Error Found Please contact the Admin"
        );
      }
      store.stopLoading();
    });
  }
  function Submit() {
    store.startLoading();
    let data = store.getrecord();
    data.modifiedBy = store.getuser().id;
    data.createdBy = store.getuser().id;
    console.log({ setrecord, data });

    if (CheckMandatory("trademark_project", store)) {
      saveRecord(setrecord, data).then(async (res) => {
        console.log("Resonce of saveRecord - ", res);
        if (res.success) {
          SuccessAlert(
            "Project Submitted Successfully"
          );
          await createTemplatetask(data, res?.Id?.projectDetails?.id);
          store.stopLoading();
          store.navTo(
            "/" +
            URLPRIFIX +
            "/trademark/projects/view/" +
            res.Id.projectDetails.id,
            { replace: true }
          );
        } else {
          store.stopLoading();
          ErrorAlert(
            res?.errormessage?.response?.data ||
            " Error Found Please contact the Admin"
          );
        }
        store.stopLoading();
      });
    }
  }
  function NavigateToInvoice(company_id) {
    let contact_id = store.getvalue("contact_id");
    console.log("GenerateInvoice contact_id ", contact_id);
    // GetRecords("/contact/contacts/" + contact_id).then((res) => {
    // if (res.success) {
    // res = res?.record?.parent || [];
    // if (res.length > 0) {
    //   res = res[0].client_id;
    // if (res != null || res != undefined) {
    store.navTo(
      "/" +
      URLPRIFIX +
      "/" +
      company_id +
      "/accounts/invoice/create?proj_id=" +
      id +
      "&cust_id=" +
      contact_id
    );
    // } else {
    //   ErrorAlert(
    //     "No Client Name Found, Please update the contact with proper Client Name"
    //   );
    // }
    // }
    // }
    // });
  }

  return (
    <FormView
      actions={[
        {
          Name: "Back",
          onclick: () => {
            // store.navTo("/" + URLPRIFIX + "/projects/list");
            store.navback();
            store.reset(init);
          },
          visible: true,
        },
        {
          Name: "Edit",
          onclick: () => {
            store.navTo(`/${URLPRIFIX}/trademark/projects/edit/${id}`, {
              replace: true,
            });
          },
          visible: option === "view" && store.getprops("update"),
        },
        {
          Name: "Generate Invoice",
          onclick: () => {
            // api/v2/Customer/getclient/2
            // GetRecords(
            //   "/contact/contacts/" + store.getvalue("contact_id")
            // ).then((res) => {
            //   if (res.success) {
            //     res = res?.record?.parent[0] || {};
            //     res = res.client_id;
            GetRecords(
              "/contact/companycontacts/" + store.getvalue("contact_id")
            ).then((client) => {
              if (client.success) {
                client = client?.record || {};
                client = client?.company_id?.map((item) => ({
                  value: item.company_id,
                  label: item.company_name,
                }));
                setCompanyList((prev) => {
                  return [...prev, ...client];
                });
                //   }
                //   console.log("Generate Invoice", client);
                // }
                // );
              }
            });

            setGenerateInvoice(true);
          },
          type: "primary",
          visible: option === "view" && [1, 4].includes(user.role),
        },
        {
          Name: "Submit",
          onclick: Submit,
          type: "primary",
          visible: id === undefined,
        },
        {
          Name: "Update",
          onclick: update,
          type: "primary",
          visible: option === "edit" && store.getprops("update"),
        },
        {
          Name: "Create Task",
          type: "primary",
          onclick: () => {
            let data = store.getrecord();
            console.log("autofill check On Create Project - ", data, id);

            store.setrecord("trademark_task", {
              project_id: id,
              form_id: "0",
              // film_id: "",
              contact_id: data.contact_id,
              task_id: "0",
              subtask_title: "",
              assigned_to: "0",
              dueDate: "",
              priority: "Medium",
              status: "Draft",
              description: "",
              hold_note: "",
              rejected_reason: "",
              complete_note: "",
              comments: "",
              activeStatus: true,
              attachmenturl: [],
              child: [],
            });
            store.navTo("/demo/trademark/tasks/create?project_id=readonly");
          },
          visible:
            option === "view" && getlocal("properties")?.trademark_task?.add,
        },
      ]}
    >
      {GenerateInvoice && (
        <div className="absolute flex h-[80%] w-[95%] rounded-lg z-50 bg-black bg-opacity-15 backdrop-blur-sm justify-center items-center">
          <div className="flex flex-col items-center bg-secondary px-20 py-5 rounded-lg">
            <h1 className="font-bold">Please confirm the Company</h1>
            <div className="flex flex-col pt-6 pb-10 w-[80%]">
              <label>Company Name</label>
              <select
                className=" flex w-full border rounded-lg"
                onChange={(event) => {
                  setCompanyNumber(event.target.value);
                }}
              >
                {CompanyList.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex justify-evenly w-full">
              <button
                className={secondaryBTN}
                onClick={() => {
                  setGenerateInvoice(false);
                }}
              >
                Back
              </button>
              <button
                className={PrimaryBTN}
                onClick={() => {
                  if (CompanyNumber != "") {
                    NavigateToInvoice(CompanyNumber);
                  } else {
                    ErrorAlert(
                      "Please choose the company for generate invoice."
                    );
                  }
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="grid grid-cols-2 max-md:grid-cols-1 gap-6">
        <String name="projectName" label="Project Name :" />

        <Dropdown
          name="contact_id"
          label="Customer Name :"
          list={store.getprops("clientname_list") || []}
        //  onchange={(event) => {
        //   let clientname_list = store.getprops("clientname_list") || [];
        //   clientname_list = clientname_list.filter(
        //     (item) => item.value == event
        //   )[0];
        //   store.setvalue("clientName", clientname_list?.label);
        // }}
        />
        <Dropdown
          name="priority"
          label="Priority :"
          list={[
            { value: "High", label: "High" },
            { value: "Medium", label: "Medium" },
            { value: "Low", label: "Low" },
          ]}
        />
        {option === undefined && (
          // <Dropdown
          //   name="taskTemplate"
          //   label="Template :"
          //   list={store.getprops("taskTemplate_list") || []}
          // />
          <Dropdown
            name="taskTemplate" // This will store the ID
            label="Template :"
            list={store.getprops("taskTemplate_list") || []}
          />
        )}
        <div className="col-span-2 max-md:col-span-1">
          <Journal
            name="projectDescription"
            label="Project Description :"
            doubleline={true}
          />
        </div>
        <Dropdown
          name="status"
          label="Status :"
          list={[
            { value: "Draft", label: "Draft" },
            { value: "inprogress", label: "InProgress" },
            { value: "hold", label: "Hold" },
            { value: "completed", label: "Completed" },
            { value: "billed", label: "Billed" },
          ]}
        />
        <Dropdown
          name="activeStatus"
          label="Active Status :"
          list={[
            { value: true, label: "Active" },
            { value: false, label: "InActive" },
          ]}
        />

        <DatePicker name="startDate" label="Start Date :" />
        <DatePicker name="endDate" label="End Date :" />
        <div className="col-span-2 max-md:col-span-1 px-2">
          <div className="font-bold text-[20px]">Attachements</div>
          <div className="grid grid-cols-5">
            {store.getvalue("attachmenturl")?.length > 0 ? (
              store.getvalue("attachmenturl").map((item, index) => {
                // console.log("test 223", item);
                return (
                  <div className="col-span-1 flex border-r pr-6 w-full  items-center">
                    <Attachement name={"attachmenturl"} fileurl={item} />
                    <button
                      className="hover:bg-tertiary p-1 h-fit w-fit rounded-full"
                      onClick={() => {
                        let arr = [];
                        store
                          .getvalue("attachmenturl")
                          .map((attachitem, attachindex) => {
                            if (attachindex !== index) {
                              arr.push(attachitem);
                            }
                          });
                        store.setvalue("attachmenturl", arr);
                      }}
                    >
                      X
                    </button>
                  </div>
                );
              })
            ) : (
              <>No Data</>
            )}
            {option !== "view" && (
              <FileInput
                prefix={"project" + id}
                onchange={(file) => {
                  let attachmenturl = store.getvalue("attachmenturl") || [];
                  attachmenturl.push(file);
                  store.setvalue("attachmenturl", attachmenturl);
                }}
              />
            )}
          </div>
        </div>

        {option === "view" && (
          <ChildTabsView
            className="col-span-2 max-md:col-span-1 mt-1"
            tabsList={store.getvalue("child") || {}}
            store={store}
            LoadInitData={LoadInitData}
          />
        )}
      </div>
    </FormView>
  );
};

function ChildTabsView({ tabsList = {}, className = "", store, LoadInitData }) {
  const props = getlocal("properties");
  const user = getlocal("system")?.user || {};
  const [tabs, settabs] = useState(
    props.nonlitigation_tasks.view ? "tasks" : ""
  );
  const [selected, setselected] = useState([]);
  function handleSelect(record, select) {
    if (select) {
      setselected((prev) => {
        prev.push(record);
        return [...prev];
      });
    } else {
      setselected((prev) => {
        prev = prev.filter((item) => item.id != record.id);
        return [...prev];
      });
    }
  }

  useEffect(() => {
    setselected([]);
  }, []);
  useEffect(() => {
    console.log("handleSelect selected", selected);
  }, [selected]);
  // const handleRowEditSave = async (updatedItem) => {
  //   const payload = {
  //     ...updatedItem,
  //     activeStatus: true,
  //     modifiedBy: user.id,
  //   };
  //   // console.log("EDITED formatted:", payload);

  //   const result = await UpdateRecord(`/subtask/updatesubtask/${updatedItem.id}`, payload);
  //   console.log("Update result:", result);

  //   if (result?.success) {
  //     SuccessAlert("Task updated successfully.");
  //     LoadInitData();
  //   } else {
  //     ErrorAlert("Failed to update task.");
  //   }
  // };
  const handleRowEditSave = async (updatedItem) => {
    const payload = {
      ...updatedItem,
      activeStatus: true,
      modifiedBy: user.id,
    };

    // 1. Save the current task update
    const result = await UpdateRecord(`/subtask/updatesubtask/${updatedItem.id}`, payload);

    if (result?.success) {
      if (updatedItem.status === "completed") {
        try {
          // 2. Recalculate timeline on backend
          await UpdateRecord(
            `/subtask/recalculate-timeline/${updatedItem.project_id}/${updatedItem.id}`,
            {}
          );

          // 3. Find the "Next Task" in the current state to identify the person
          // We look for the task with an order_index immediately after the current one
          const currentTasks = enrichedList; // or currentTab.list depending on your scope
          const nextTask = currentTasks
            .filter(t => t.status !== "completed" && t.id !== updatedItem.id)
            .sort((a, b) => a.order_index - b.order_index)[0];

          // 4. Show Conditional Success Alerts
          SuccessAlert("Task completed successfully.");

          if (nextTask) {
            const personName = nextTask.assigned_to_username || "the assigned user";
            SuccessAlert(`Next Task: "${nextTask.subtask_title}" is assigned to ${personName}`);
          } else {
            // No next task found means this was the final task
            SuccessAlert("All tasks in this workflow are now complete!");
          }

        } catch (err) {
          console.error("Timeline shift or notification failed", err);
        }
      } else {
        SuccessAlert("Task updated successfully.");
      }

      // 5. Refresh data to show new dates and updated statuses
      LoadInitData();
    } else {
      ErrorAlert("Failed to update task.");
    }
  };
  const handleBulkUpdate = async () => {
    const assignedToValue = store.getvalue("assigned_to");
    if (!assignedToValue || assignedToValue <= 0) {
      ErrorAlert("Please select a valid user to assign.");
      return;
    }

    const taskIds = selected.map(item => item.id);
    if (taskIds.length === 0) {
      ErrorAlert("No tasks selected.");
      return;
    }

    const bulkUpdateRequest = {
      task_ids: taskIds,
      assigned_to: assignedToValue,
      due_date: null, // Not used in current UI
      modified_by: user.id,
    };

    try {
      const result = await UpdateRecord(`/subtask/bulkupdatetasks/13`, bulkUpdateRequest);
      console.log("Bulk update result:", result);

      if (result?.success) {
        SuccessAlert(`Bulk update successful. Updated ${result.updatedCount || taskIds.length} tasks.`);
        LoadInitData();
        setselected([]);
        store.setvalue("assigned_to", ""); // Clear the dropdown
      } else {
        ErrorAlert(result?.errormessage?.data || "Bulk update failed. Please try again.");
      }
    } catch (error) {
      console.error("Bulk update error:", error);
      ErrorAlert("An error occurred during bulk update. Please contact the admin.");
    }
  };

  const dropdownOptions = {
    assigned_to_username: store.getprops("userName_list") || [{ value: 0, label: "Unassigned" }],
    priority: [
      { value: "High", label: "High" },
      { value: "Medium", label: "Medium" },
      { value: "Low", label: "Low" },
    ],
    status: [
      { value: "Draft", label: "Draft" },
      { value: "inprogress", label: "Inprogress" },
      { value: "hold", label: "Hold" },
      { value: "waitingforapproval", label: "Waiting For Approval" },
      { value: "approved", label: "Approved" },
      { value: "rejected", label: "Rejected" },
      { value: "completed", label: "Completed" },
      { value: "closedcompleted", label: "Closed Completed" },
    ],
  };
  const dateFields = ["dueDate"];
  const currentTab = tabsList[tabs] || { header: [], list: [] };
  const enrichedList = (currentTab.list || []).map(record => ({
    ...record,
    assigned_to_username: record.assigned_to_username || "Unassigned",
    activeStatus: record.activeStatus ? "Active" : "InActive"
  }));
  return (
    <div className={className}>
      <div className="flex justify-between items-center border-b border-gray-200 dark:border-gray-700 dark:text-gray-400">
        <ul
          className={
            className +
            " flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400"
          }
        >
          <li className="me-2">
            {props.forms.view && tabsList?.tasks?.list?.length > 0 && (
              <button
                className={
                  " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
                  ("tasks" === tabs
                    ? " bg-Ocean_Blue text-secondary "
                    : " bg-Alice_Blue ")
                }
                onClick={() => {
                  settabs("tasks");
                }}
              >
                {"Tasks" +
                  (("tasks" === tabs && " - " + tabsList[tabs]?.list?.length) ||
                    "")}
              </button>
            )}

            {props.invoices.view && tabsList?.invoices?.list?.length > 0 && (
              <button
                className={
                  " p-2 text-primary text-[16px] rounded-t-lg hover:bg-tertiary hover:text-primary " +
                  ("invoices" === tabs
                    ? " bg-Ocean_Blue text-secondary "
                    : " bg-Alice_Blue ")
                }
                onClick={() => {
                  settabs("invoices");
                }}
              >
                {"Invoices" +
                  (("invoices" === tabs &&
                    " - " + tabsList[tabs]?.list?.length) ||
                    "")}
              </button>
            )}
          </li>
        </ul>
        {tabs === "tasks" && selected.length > 0 && (
          <div className="flex items-center">
            <Dropdown
              className={{ lable: "min-w-fit", field: "", input: "" }}
              name="assigned_to"
              label="Assigned To :"
              list={
                store.getprops("userName_list") || [
                  {
                    value: 0,
                    label: "UnAssigned",
                  },
                ]
              }
            />
            <button
              className={
                "py-2 px-6 rounded-xl font-bold text-[12px] h-fit" +
                // +
                // (action.type === "primary"
                " bg-primary text-secondary"
                //   : " bg-tertiary text-primary")
              }
              onClick={handleBulkUpdate}
            >
              Save
            </button>
          </div>
        )}
      </div>


      {/* Editable Table */}
      <EditableTable
        headers={currentTab.header}
        // records={currentTab.list}
        records={enrichedList}
        selected={selected}
        onSelect={handleSelect}
        onRowClick={(item) => {
          store.removemodule("trademark_task");
          if (tabs === "invoices") {
            store.navTo(
              "/" +
              URLPRIFIX +
              "/" +
              item.company_id +
              "/accounts/invoice/view/" +
              item?.id
            );
          }
          else {
            store.navTo(`/${URLPRIFIX}/trademark/tasks/view/${item.id}`);

          }
        }}
        onSaveEdit={handleRowEditSave}
        ondelete={
          tabs === "tasks" && props.nonlitigation_documents.delete
            ? (item) => {
              DeleteRecord("/subtask/deletesubtask/" + item.id, {
                modifiedBy: store.getuser().id,
              }).then((res) => {
                if (res.success) {
                  SuccessAlert("Deleted Successfully");
                  LoadInitData();
                }
                else if (res.code == 302) {
                  WarningAlert("User cancelled deletion")
                }
                else {
                  ErrorAlert(
                    res?.errormessage?.response?.data ||
                    "Unknown Error Found Please contact the Admin"
                  );
                }
              });
            }
            : undefined
        }


        dropdownOptions={dropdownOptions}
        dateFields={dateFields}
      />
    </div>
  );
}
function EditableTable({
  headers,
  records,
  selected,
  onSelect,
  onRowClick,
  onSaveEdit,
  ondelete,
  dropdownOptions = {},
  dateFields = [],
}) {
  const [editRowId, setEditRowId] = useState(null);
  const [editData, setEditData] = useState({});

  const handleCheckboxChange = (record, isChecked) => {
    onSelect(record, isChecked);
  };

  const handleBulkSelect = (e) => {
    const isChecked = e.target.checked;
    records.forEach((rec) => onSelect(rec, isChecked));
  };

  const startEdit = (record) => {
    setEditRowId(record.id);
    setEditData({ ...record });
  };

  const saveEdit = () => {
    if (editRowId !== null) {
      onSaveEdit(editData);
      setEditRowId(null);
    }
  };

  const cancelEdit = () => {
    setEditRowId(null);
    setEditData({});
  };

  return (
    <table className="min-w-full border mt-4">
      <thead className="bg-gray-100">
        <tr>
          <th className="p-2 border">
            <input
              type="checkbox"
              checked={selected.length === records.length && records.length > 0}
              onChange={handleBulkSelect}
              onClick={(e) => e.stopPropagation()}
            />
          </th>
          <th className="p-2 border">S.No</th>
          {headers.map(([label, key]) => (
            <th key={key} className="p-2 border text-left">
              {label}
            </th>
          ))}
          <th className="p-2 border">Actions</th>
        </tr>
      </thead>
      <tbody>
        {records.map((row, index) => {
          const isSelected = selected.some((s) => s.id === row.id);
          const isEditing = editRowId === row.id;
          const titleColumnKey = headers[0]?.[1];

          return (
            <tr
              key={row.id}
              className={`hover:bg-gray-50 ${isEditing ? "bg-yellow-50" : ""
                }`}
            // onClick={() => {
            //   if (!isEditing) onRowClick(row);
            // }}
            >
              <td className="p-2 border">
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={(e) =>
                    handleCheckboxChange(row, e.target.checked)
                  }
                  onClick={(e) => e.stopPropagation()}
                />
              </td>
              <td className="p-2 border">{index + 1}</td>
              {headers.map(([label, key]) => (
                <td key={key} className="p-2 border">
                  {isEditing ? (
                    dropdownOptions[key] ? (
                      <select
                        className="border p-1 w-full"
                        // value={editData[key] || ""}
                        // onChange={(e) =>
                        //   setEditData({
                        //     ...editData,
                        //     [key]: e.target.value,
                        //   })
                        // }
                        value={
                          key === "assigned_to_username"
                            ? editData.assigned_to
                            : editData[key] || ""
                        }
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            [key === "assigned_to_username" ? "assigned_to" : key]:
                              e.target.value
                          })
                        }
                        onClick={(e) => e.stopPropagation()}
                      >
                        <option value="">Select</option>
                        {dropdownOptions[key].map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    ) : dateFields.includes(key) ? (
                      <input
                        type="date"
                        className="border p-1 w-full"
                        value={editData[key] ? editData[key].slice(0, 10) : ""}
                        onChange={(e) => {
                          const isoDate = e.target.value
                            ? new Date(e.target.value).toISOString()
                            : "";
                          setEditData({ ...editData, [key]: isoDate });
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                    ) : (
                      <input
                        className="border p-1 w-full"
                        value={editData[key] || ""}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            [key]: e.target.value,
                          })
                        }
                        onClick={(e) => e.stopPropagation()}
                      />
                    )
                  ) : (
                    // **VIEW MODE: Display data**
                    key === titleColumnKey ? (
                      /* **TITLE CELL: CLICKABLE + HIGHLIGHTED** */
                      <div
                        className="cursor-pointer text-blue-600 hover:text-blue-800 hover:underline font-semibold flex items-center"
                        onClick={(e) => {
                          e.stopPropagation();
                          onRowClick(row);
                        }}
                      >
                        <span className="mr-1 text-xs">🔗</span>
                        {row[key]}
                      </div>
                    ) : (
                      /* **OTHER CELLS: NON-CLICKABLE** */
                      <span className="cursor-default">{row[key]}</span>
                    )
                  )}
                </td>
              ))}
              <td className="p-2 border whitespace-nowrap">
                {isEditing ? (
                  <>
                    <button
                      className="text-green-600 mr-2"
                      onClick={(e) => {
                        e.stopPropagation();
                        saveEdit();
                      }}
                    >
                      <FaCheck />

                    </button>
                    <button
                      className="text-gray-600"
                      onClick={(e) => {
                        e.stopPropagation();
                        cancelEdit();
                      }}
                    >
                      <FaTimes />
                    </button>
                  </>
                ) : (
                  <>

                    <button
                      className="text-blue-600"
                      onClick={(e) => {
                        e.stopPropagation();
                        startEdit(row);
                      }}
                    >
                      <FaEdit />
                    </button>
                    &nbsp;&nbsp;
                    {ondelete && (
                      <button
                        className="text-red-600"
                        onClick={(e) => {
                          e.stopPropagation();
                          ondelete(row);
                        }}
                      >
                        <FaTrash />
                      </button>
                    )}
                  </>


                )}
              </td>
            </tr>
          );
        })}
        {records.length === 0 && (
          <tr>
            <td
              colSpan={headers.length + 3}
              className="text-center p-4 text-gray-500"
            >
              No records found.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default TProjectForm;